import alert_mixin from '@/utils/mixins/alert_mixin';
import {
    CREATE_FORM_STATUS,
    get_headers,
    get_project_id,
    get_token,
    VIEW_FORM_STATUS,
    EDIT_FORM_STATUS
} from '@/utils/constants/constants.js';
import axios from 'axios';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import 'datatables.net';
import $ from 'jquery';
import {
    validate_non_empty_string,
    get_error_message
} from '@/utils/validations/validate_inputs';

export default {
  name: 'StatusManagement',
  mixins: [alert_mixin], // Add loader_mixin here
  data: () => ({
    headers: get_headers(),
    token: get_token(),
    project_id: get_project_id(),
    form_status_name: '',
    form_status_color: '', // Default color for new entries
    status_created: [],
    update_form_status_name: '',
    update_form_status_color: '',
    form_status_id: null,
    dataTable: null,
  }),
  mounted() {
    this.view_form_status()
  },
  methods: {
     async create_form_status() {
      if (!validate_non_empty_string(this.form_status_name)) {
        this.show_error('Status name must not be empty');
        return;
      }
      
      const payload = {
        project_id: this.project_id,
        status: this.form_status_name,
        color_code: this.form_status_color // Send color to backend
      }

      // Show loader using your mixin method
      let loader = null;
      try {
        loader = await this.show_loader("Creating status...");

        let response = await axios.post(CREATE_FORM_STATUS, payload, {
          headers: this.headers
        });

        const response_data = response.data;
        if(response_data.status === 'success' || response_data.message === 'success') {
          this.show_success('Form status created successfully.');
          this.close_modal('create_form_status');
          // Refresh the data
          window.location.reload();
          // Reset form
          this.form_status_name = '';
          this.form_status_color = '';
          
        } else {
          this.show_error('Error creating status.');
        }
                
      } catch (error) {
        const final_message = get_error_message(error);
        this.show_error(`Error creating form status: ${final_message}`);
      } finally {
        // Close loader using your mixin method
        if (loader) {
          this.close_loader(loader);
        }
      }
    },

    async view_form_status() {
      const payload = { project_id: this.project_id };
      let loader = null;

      try {
        // Show loader before fetching data
        loader = await this.show_loader("Loading statuses...");
        
        let response = await axios.get(VIEW_FORM_STATUS, {
          headers: this.headers,
          params: payload
        });
        
        this.status_created = response.data.data.map((statuses) => ({
          id: statuses.id,
          form_status_name: statuses.status.replace(/_/g, ' '),
          color: statuses.color_code || statuses.color  // Handle both field names
        }));
        
        this.init_data_table();
        
        // Close loader after data is loaded
        if (loader) {
          this.close_loader(loader);
        }

      } catch (error) {
        this.show_error(`Error fetching status: ${error.response?.data?.message}`);
        // Close loader on error too
        if (loader) {
          this.close_loader(loader);
        }
      }
    },

    prepopulate_edit_modal(row) {
      this.update_form_status_name = row.form_status_name;
      this.update_form_status_color = row.color;
      this.form_status_id = row.id;
    },

    async update_form_status() {
      if (!validate_non_empty_string(this.update_form_status_name)) {
        this.show_error('Status name must not be empty');
        return;
      }

      // Ensure color has a value
      if (!this.update_form_status_color) {
        this.update_form_status_color = '';
      }

      const payload = {
        status: this.update_form_status_name,
        status_id: this.form_status_id,
        color_code: this.update_form_status_color // Include color in update
      };

      // Show loader using your mixin method
      let loader = null;
      try {
        loader = await this.show_loader("Updating status...");

        let response = await axios.post(EDIT_FORM_STATUS, payload, {
          headers: this.headers
        });

        const response_data = response.data;
        if (response_data.status === 'success') {
          this.show_success('Form status updated successfully.');
          this.close_modal('update_form_status');
          window.location.reload();
        } else {
          this.show_error('Error while updating form status');
        } 
              
      } catch (error) {
        this.show_error(`Error updating form status: ${error.response?.data?.message}`);
      } finally {
        // Close loader using your mixin method
        if (loader) {
          this.close_loader(loader);
        }
      }
    },

    init_data_table() {
      this.$nextTick(() => {
        if (this.dataTable) {
          this.dataTable.destroy();
        }
        
        this.dataTable = $('#status_table').DataTable({
          responsive: true,
          emptyTable: "No data available in table",
          language: {
            info: "", // Capitalized "Entries"
            lengthMenu: "_MENU_&nbsp;&nbsp;Entries per page" // Added non-breaking space
          }
        });
      });
    },
  }
}